import React from 'react'
import { ComponentExt } from 'util/reactExt'
import styles from './index.scss'
import { Radio, Input, Checkbox } from 'antd'

const { TextArea } = Input

// const Panel = Collapse.Panel
const RadioGroup = Radio.Group

// const answerFormatter = (answer, n = 9) =>
//   answer.length > n ? answer.slice(0, n) + '...' : answer

interface ExamCardProps {
  index: number | string
  type: string
  content: string
  score: string
  options: any[]
  id: string
  exerciseid: string
  answers?: any[]
  answer_count: number
  onPostAnwser: (id, answer) => void
}

class ExamCard extends ComponentExt<ExamCardProps> {
  state = {
    collape: true,
    right: true,
    answer: Array(this.props.answer_count || 1).fill(''),
    showAnwser: false,
    reaction: null,
    collected: false,
  }

  renderExerciseByType = type => {
    const typeMap = {
      单选: this.renderSingleChoice,
      多选: this.renderMutiChoice,
      填空: this.renderCompletion,
      综合: this.renderIntegration,
      判断: this.renderSingleChoice,
    }

    return typeMap[type] || (() => void 0)
  }

  test = e => {
    const collape = !e.length
    this.setState({
      collape,
    })
  }

  postAnwser(answer) {
    const { index } = this.props
    this.props.onPostAnwser(Number(index) - 1, answer)
  }

  handleCollectExamTitle = async () => {
    const { id } = this.props
    const { collected } = this.state
    try {
      if (collected) {
        // await this.api.exam.cancelCollectExamTitle(id)
      } else {
        // await this.api.exam.collectExamTitle(id)
      }

      this.setState({
        collected: !this.state.collected,
      })
    } catch (e) {}
  }
  handleChoice = e => {
    const answer = [e.target.value]
    this.setState({
      answer,
    })
    this.postAnwser(answer)
  }

  handleMutiChoice = e => {
    const answer = e
      .sort()
      .toString()
      .replace(/,/g, '')
    this.setState({
      answer: [answer],
    })
    this.postAnwser([answer])
  }
  handleCompletionInput = (e, idx) => {
    const answer = this.state.answer

    answer[idx] = e.target.value
    this.setState({
      answer,
    })

    const result = [
      answer.reduce((prev, current) => {
        return `${prev} ${current}`
      }, ''),
    ]
    this.postAnwser(result)
  }
  handleInput = e => {
    const answer = [e.target.value]
    this.setState({
      answer,
    })
    this.postAnwser(answer)
  }
  renderSingleChoice = () => {
    const { showAnwser } = this.state
    const options = this.props.options
    return (
      <RadioGroup
        disabled={showAnwser}
        name="radiogroup"
        onChange={this.handleChoice}
      >
        {options.map((item, i) => (
          <Radio key={i} className={styles.radioItem} value={item.value}>
            <span
              style={{ display: 'flex' }}
              dangerouslySetInnerHTML={{ __html: `${item.order}.${item.text}` }}
            />
          </Radio>
        ))}
      </RadioGroup>
    )
  }

  renderMutiChoice = () => {
    const { answer, showAnwser } = this.state
    const options = this.props.options
    return (
      <div className={styles.mutiChoice}>
        <Checkbox.Group disabled={showAnwser} onChange={this.handleMutiChoice}>
          {options.map((item, i) => (
            <Checkbox key={i} className={styles.radioItem} value={item.value}>
              <span
                style={{ display: 'flex' }}
                dangerouslySetInnerHTML={{
                  __html: `${item.order}.${item.text}`,
                }}
              />
            </Checkbox>
          ))}
        </Checkbox.Group>
      </div>
    )
  }

  renderCompletion = () => {
    const { answer, showAnwser } = this.state
    const { answer_count } = this.props
    return (
      <div>
        {Array(answer_count || 1)
          .fill('')
          .map((x, idx) => (
            <TextArea
              rows={1}
              disabled={showAnwser}
              autosize
              value={answer[idx]}
              style={{
                width: `${940 / Number(answer_count) - 10}px`,
                margin: '0 5px 14px',
              }}
              onChange={e => this.handleCompletionInput(e, idx)}
            />
          ))}
      </div>
    )
  }
  renderIntegration = () => {
    const { answer, showAnwser } = this.state
    return (
      <div>
        <TextArea
          disabled={showAnwser}
          style={{ marginBottom: 14 }}
          rows={4}
          autosize={{ minRows: 4 }}
          onChange={this.handleInput}
          value={answer}
        />
      </div>
    )
  }
  render() {
    const { index, type, content, score } = this.props
    return (
      <div className={styles.exerciseCard}>
        <h4>
          <span>
            {index}.<span className={styles.type}>【{type}题】</span>&nbsp;
            <span
              className={styles.cardTitle}
              dangerouslySetInnerHTML={{ __html: `${content}` }}
            />
          </span>
        </h4>
        {this.renderExerciseByType(type)()}
      </div>
    )
  }
}

export default ExamCard
